namespace $ {

	export class $shm_hitalama_map_history_storage_meta extends $giper_baza_entity.with({
		Version: $giper_baza_atom_real,
		Legacy_migrated: $giper_baza_atom_bool,
		Writers_migrated: $giper_baza_atom_bool,
	}) {

		version( next?: number ) {
			this.keys()
			let value = this.Version()
			if( !value && next !== undefined ) {
				this.Version( null )
				value = this.Version()
			}
			return value?.val( next ) ?? 0
		}

		legacy_migrated( next?: boolean ) {
			this.keys()
			let value = this.Legacy_migrated()
			if( !value && next !== undefined ) {
				this.Legacy_migrated( null )
				value = this.Legacy_migrated()
			}
			return value?.val( next ) ?? false
		}

		writers_migrated( next?: boolean ) {
			this.keys()
			let value = this.Writers_migrated()
			if( !value && next !== undefined ) {
				this.Writers_migrated( null )
				value = this.Writers_migrated()
			}
			return value?.val( next ) ?? false
		}

	}

}
